import { useEffect, useState } from 'react';
import confetti from 'canvas-confetti';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

// Aktivlogg brand colors for confetti
const COLORS = ['#EAB308', '#FBBF24', '#FDE047', '#FFFFFF', '#F59E0B', '#D97706'];

const BirthdayGreeting = () => {
  const [show, setShow] = useState(false);
  const [name, setName] = useState('');

  useEffect(() => {
    const checkBirthday = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const res = await axios.get(`${API_BASE}/api/auth/birthday-check`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (res.data.show_birthday) {
          setName(res.data.name);
          setShow(true);
          fireCelebration();

          // Mark as celebrated in DB (prevents showing again this year)
          await axios.post(`${API_BASE}/api/auth/birthday-celebrated`, {}, {
            headers: { Authorization: `Bearer ${token}` }
          });

          setTimeout(() => setShow(false), 4000);
        }
      } catch (err) {
        // Silent fail
      }
    };

    // Small delay to ensure page has rendered after login
    const timer = setTimeout(checkBirthday, 500);
    return () => clearTimeout(timer);
  }, []);

  const fireCelebration = () => {
    const duration = 3000;
    const end = Date.now() + duration;

    const frame = () => {
      // Left cannon
      confetti({
        particleCount: 8,
        angle: 80,
        spread: 60,
        origin: { x: 0, y: 1 },
        colors: COLORS,
        zIndex: 10001,
        startVelocity: 90,
        gravity: 0.8
      });

      // Right cannon
      confetti({
        particleCount: 8,
        angle: 100,
        spread: 60,
        origin: { x: 1, y: 1 },
        colors: COLORS,
        zIndex: 10001,
        startVelocity: 90,
        gravity: 0.8
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };

    frame();
  };

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{ zIndex: 10000, backgroundColor: 'rgba(0, 0, 0, 0.75)' }}
      onClick={() => setShow(false)}
      data-testid="birthday-overlay"
    >
      <div className="text-center animate-fade-in">
        <p className="text-4xl md:text-5xl font-bold text-white">
          Gratulerer med dagen, {name}!
        </p>
      </div>
    </div>
  );
};

export default BirthdayGreeting;
